"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var authentication_service_1 = require("../shared/service/authentication.service");
var url_1 = require("./url");
var TokenInterceptor = /** @class */ (function () {
    function TokenInterceptor(authenticationService) {
        this.authenticationService = authenticationService;
    }
    TokenInterceptor.prototype.intercept = function (req, next) {
        if (!req.url.includes('geonames')) {
            var credentials = this.authenticationService.getCredentials();
            var newReq = credentials ? req.clone({
                setHeaders: {
                    authorization: credentials
                },
                url: url_1.Urls.getBaseUrlApi() + req.url
            }) : req.clone({
                url: url_1.Urls.getBaseUrl() + req.url
            });
            return next.handle(newReq);
        }
        return next.handle(req);
    };
    TokenInterceptor.ctorParameters = function () { return [{ type: authentication_service_1.AuthenticationService }]; };
    return TokenInterceptor;
}());
exports.TokenInterceptor = TokenInterceptor;
//# sourceMappingURL=token-interceptor.js.map


// WEBPACK FOOTER //
// token-interceptor.js